function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 7a1 1 0 011-1h18a1 1 0 011 1v18a1 1 0 01-1 1H7a1 1 0 01-1-1V7z",
  fill: "#29354C"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11 11h10v2H11zM11 15h10v2H11zM11 19h10v2H11z"
});

var SvgIconMaterial = function SvgIconMaterial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYgN0M2IDYuNDQ3NzIgNi40NDc3MiA2IDcgNkgyNUMyNS41NTIzIDYgMjYgNi40NDc3MiAyNiA3VjI1QzI2IDI1LjU1MjMgMjUuNTUyMyAyNiAyNSAyNkg3QzYuNDQ3NzIgMjYgNiAyNS41NTIzIDYgMjVWN1oiIGZpbGw9IiMyOTM1NEMiLz4KPHJlY3QgeD0iMTEiIHk9IjExIiB3aWR0aD0iMTAiIGhlaWdodD0iMiIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iMTEiIHk9IjE1IiB3aWR0aD0iMTAiIGhlaWdodD0iMiIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iMTEiIHk9IjE5IiB3aWR0aD0iMTAiIGhlaWdodD0iMiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgIconMaterial as ReactComponent };